import { render, staticRenderFns } from "./GreetingQuizSlot.vue?vue&type=template&id=746066c0&scoped=true&"
import script from "./GreetingQuizSlot.vue?vue&type=script&lang=js&"
export * from "./GreetingQuizSlot.vue?vue&type=script&lang=js&"
import style0 from "./GreetingQuizSlot.vue?vue&type=style&index=0&id=746066c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746066c0",
  null
  
)

export default component.exports